import Constants from '@/Constants';
import http from '@/services/HttpService';
import { call, put } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { updatePersonAchievementsInfo } from '../identity/action';
import {
    listAchievementsFailure,
    listAchievementsSuccess,
    updateAchievementsInfoFailure,
    updateAchievementsInfoSuccess,
    updateAchievementsNotificationFailure,
    updateAchievementsNotificationSuccess,
} from './actions';
import { AchievementsTypes } from './types';

export function* updateAchievementsNotification(action: PayloadAction<AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_REQUEST, number>) {
    try {
        yield call(http.post, Constants.CAST_ACHIEVEMENTS_NOTIFICATION_READ_URI.replace('%personBadgeId', action.payload.toString()));
        yield put(updateAchievementsNotificationSuccess());
    } catch (error) {
        yield put(updateAchievementsNotificationFailure());
    }
}

export function* updateAchievementsInfo(action: PayloadAction<AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_REQUEST, boolean>) {
    try {
        yield call(http.post, Constants.CAST_ACHIEVEMENTS_INFO_READ_URI, action.payload);
        yield put(updateAchievementsInfoSuccess());
        yield put(updatePersonAchievementsInfo(true));
    } catch (error) {
        yield put(updateAchievementsInfoFailure());
    }
}

export function* listAchievementsRequest(action: PayloadAction<AchievementsTypes.LIST_ACHIEVEMENTS_REQUEST, number>) {
    try {
        const { data } = yield call(http.get, Constants.CAST_GET_ACHIEVEMENTS_URI.replace('%p', action.payload.toString()));
        yield put(listAchievementsSuccess(data));
    } catch (error) {
        yield put(listAchievementsFailure());
    }
}
